import { useQuery, useQueryClient } from "@tanstack/react-query";
import { planSummaryResponseSchema } from "../../types/planning/plan.type";
import { useApiUrls } from "../useApiUrl";
import { http } from "../../utils/httpCommon";
import { safeParsePartial } from "../../utils/zodSafeParse";
import { useIsFeatureFlagEnabled } from "../../featureFlags/useIsFeatureFlagEnabled";

export const plannedRoutesQueryKey = (date: number, sicId: number) => [
  "plannedRoutes",
  date,
  sicId,
];

export const usePlannedRoutes = (date: number, sicId: number) => {
  const hookUrls = useApiUrls();
  const { getRouteAssignments: getRouteAssignmentsUrl } = hookUrls;
  const isSafeParseEnabled = useIsFeatureFlagEnabled(
    "operations-5864-inbound-zod-parser-client"
  );

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: plannedRoutesQueryKey(date, sicId),
    queryFn: async () => {
      const url = getRouteAssignmentsUrl(date, sicId);
      const { data, status } = await http.get(url);

      if (status === 204) return [];
      return isSafeParseEnabled
        ? safeParsePartial(planSummaryResponseSchema, data, "usePlannedRoutes")
        : planSummaryResponseSchema.parse(data);
    },
  });
};

export function useInvalidateQueryPlannedRoutes() {
  const queryClient = useQueryClient();
  const invalidateQueryPlannedRoutes = (date: number, sicId: number) => {
    queryClient.invalidateQueries({
      queryKey: plannedRoutesQueryKey(date, sicId),
      exact: false,
    });
  };
  return invalidateQueryPlannedRoutes;
}
